// If this file is at: src/components/LogoMarquee/LogoMarquee.jsx
// then the logos are at: src/assets/logos/*.svg
// (ajusta rutas si tu estructura es distinta)

import shopify from "../../assets/logos/shopify.svg";
import oracle from "../../assets/logos/oracle.svg";
import googleDrive from "../../assets/logos/google-drive.svg";
import slack from "../../assets/logos/slack.svg";
import whatsapp from "../../assets/logos/whatsapp.svg";
import facebook from "../../assets/logos/facebook.svg";
import n8n from "../../assets/logos/n8n.svg";
import notion from "../../assets/logos/Notion.svg";
import salesforce from "../../assets/logos/Salesforce.svg";
import "./LogoMarquee.css";

const INTEGRATIONS = [
    { name: "Shopify",      src: shopify },
    { name: "Oracle DB",    src: oracle },
    { name: "Google Drive", src: googleDrive },
    { name: "Slack",        src: slack },
    { name: "WhatsApp",     src: whatsapp },
    { name: "Facebook",     src: facebook },
    { name: "n8n",     src: n8n },
    { name: "Notion",     src: notion },
    { name: "Salesforce",     src: salesforce },
];

export function LogoMarquee({
                                items = INTEGRATIONS,
                                speed = 36,   // segundos por ciclo (más alto = más lento)
                                gap = 20,     // px entre logos (más bajo = más juntos)
                                repeat = 5,   // cuántas veces duplicamos la tira (más alto = carrusel más largo)
                            }) {
    // Repetimos la lista 'repeat' veces para un bucle largo y sin cortes
    const strip = Array.from({ length: repeat }).flatMap((_, idx) =>
        items.map((it) => ({ ...it, _dup: idx }))
    );

    return (
        <div
            className="logo-marquee"
            style={{
                ["--marquee-duration"]: `${speed}s`,
                ["--logo-gap"]: `${gap}px`,
                ["--marquee-shift"]: `calc(-100% / ${repeat})`,
            }}
            aria-label="Integraciones compatibles"
        >
            <div className="logo-marquee__track">
                {strip.map((it, i) => (
                    <div
                        className="logo-marquee__item"
                        key={`${it.name}-${it._dup}-${i}`}
                        aria-hidden={i >= items.length ? "true" : "false"}
                    >
                        <img
                            src={it.src}
                            alt={it.name}
                            loading="lazy"
                            decoding="async"
                            draggable={false}
                            width={120}
                            height={48}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
